"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('radio');
const Radio = (props) => {
    const { children, checked, value, extra, style, onChange } = props;
    const handleClick = (e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(!checked, e, value);
    };
    return (React.createElement(one_1.View, { className: prefixCls, style: style },
        React.createElement(one_1.View, { className: `${prefixCls}-container`, onTap: handleClick },
            React.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-out-round`, {
                    [`${prefixCls}-out-round-checked`]: checked,
                }) }, checked ? React.createElement(one_1.View, { className: `${prefixCls}-inner-round` }) : null),
            React.createElement(one_1.View, { className: `${prefixCls}-children` }, children)),
        React.createElement(one_1.View, { className: `${prefixCls}-extra` }, extra)));
};
const getRadios = (children, value, onChange) => {
    const onGroupChange = (checked, e, v) => {
        const newValue = v;
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue, e);
    };
    const radios = React.Children.map(children, (radio) => {
        const newRadio = radio;
        let checked = false;
        if (newRadio && newRadio.props) {
            if ((newRadio.props.value || newRadio.props.value === 0 || newRadio.props.value === false) &&
                newRadio.props.value === value) {
                checked = true;
            }
            else {
                checked = false;
            }
            return React.createElement(Radio, Object.assign({}, newRadio.props, { checked: checked, onChange: onGroupChange }));
        }
        return newRadio;
    });
    return radios;
};
Radio.Group = (props) => {
    const { value, children, direction = 'row', onChange, style } = props;
    const radios = getRadios(children, value, onChange);
    return (React.createElement(one_1.View, { style: Object.assign({ display: 'flex', flexDirection: direction }, style) }, radios));
};
exports.default = Radio;
